// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchInput_root__S8Mpc","icon":"SearchInput_icon__6WMML","input":"SearchInput_input__IK1D8"};